<template>
  <div class="invite-page">
    <div class="invite-page-wrapper">
      <div class="tipBox">
        <div class="copyText">复制以下链接，分享给好友完成注册</div>
        <div class="timeText">活动时间：{{ campaignDays }}</div>
      </div>
      <div class="copyBox">
        {{ inviteUrl }}
        <div class="copyBtn" @click="copy">{{ copyBtnText }}</div>
      </div>
      <div class="titleBox"></div>
      <div class="invCount">{{ rankText }}</div>
      <div class="time">截至 {{ updateTime }}</div>
      <InviteList :rank="rank" :tableData="tableData" @getNextList="getNextList"></InviteList>
      <div class="info-title">活动规则：</div>
      <div class="info-content">
        1. 邀请成功3人，可获得网易有道产品总监线上培训会参会1次，帮您做好职场规划，快速成长为职场达人
      </div>
      <div class="info-content rules">
        <div class="rules-left">2. 活动结束后统计拉新排名</div>
        <div class="rules-right">
          <p v-html="'一等奖（1名）：500元严选电子卡&nbsp;&nbsp;&nbsp;&nbsp;二等奖（2名）：300元严选电子卡'"></p>
          <p v-html="'三等奖（3名）：200元严选电子卡&nbsp;&nbsp;&nbsp;&nbsp;四等奖（5名）：100元严选电子卡'"></p>
          <p>五等奖（10名）：50元严选电子卡</p>
        </div>
      </div>
      <div class="info-title">领奖说明：</div>
      <div class="info-content">1. 线上培训：活动结束后会以邮件或者短信方式通知直播培训时间及链接</div>
      <div class="info-content">
        2. 榜单获奖者领奖方式：活动结束后，10个工作日内将严选电子卡以短信形式发送到您注册的手机号，请注意查收
      </div>
      <div class="info-title">注意事项：</div>
      <div class="info-content">1. 好友通过你分享的链接完成注册，则邀请成功</div>
      <div class="info-content">2. 上榜人员最少需要邀请10人，邀请人数相同时，以完成注册的时间先后顺序进行排名</div>
      <div class="info-content">3. 被邀请者必须为本校师生</div>
      <div class="info-content info-last">
        4. 活动或产品相关问题，欢迎加入QQ群({{ this.qqGroupNum }})交流咨询
        <div class="qrCodeBox">
          QQ群二维码
          <span class="qrBtn" @mouseover="isShowqqGroupText = true" @mouseleave="isShowqqGroupText = false"></span>
          <div class="qrCode" v-show="isShowqqGroupText">
            <img :src="qqGroupRq" alt="" />
          </div>
          <div class="qqGroupText" v-show="isShowqqGroupText">
            <p>群名称：{{ qqGroupName }}</p>
            <p>群号：{{ qqGroupNum }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InviteList from '@/components/share/iniviteList'
import api from '@/services/invite/index'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      isShowqqGroupText: false,
      tableData: [],
      rank: {
        invitee: 0,
        inviterId: null,
        inviterName: '张三',
        inviterPhone: '150****2586',
        rank: 0
      },
      page: -1,
      size: 30,
      totalPage: 20,
      updateTime: '',
      qqGroupName: '-',
      qqGroupNum: '-',
      qqGroupRq: '',
      campaignDays: '',
      timer: null
    }
  },
  created() {
    this.$trackSDK._trackEvent('登录主页', '展示页面“邀请好友”')
    this.initPage()
    this.getMyOrgInfo()
  },
  computed: {
    ...mapState('headTop', ['inviteInfo', 'inviteCode']),
    copyBtnText() {
      let text = ''
      if (this.inviteInfo.waitOpen) {
        text = '活动未开启'
      } else if (this.inviteInfo.closed) {
        text = '活动结束'
      } else {
        text = '一键复制'
      }
      return text
    },
    inviteUrl() {
      return `https://doctrans-pro.youdao.com/share?inviteCode=${this.inviteCode}`
    },
    rankText() {
      //您目前已成功邀请人数：{{rank.invitee}} 人 暂无奖励，加油哦
      let text = null
      let invitee = this.rank.invitee
      if (invitee < 3) {
        text = `您目前已成功邀请人数：${invitee} 人  暂无奖励，加油哦！`
      } else if (invitee >= 3 && invitee <= 9) {
        text = `您目前已成功邀请人数：${invitee} 人  恭喜您获得线上培训机会，具体参会时间，活动结束后通知。`
      } else if (invitee >= 10) {
        text = `您目前已成功邀请人数：${invitee} 人  您已进入拉新榜单，继续努力获得严选卡！`
      }
      return text
    }
  },
  methods: {
    reponsePrompt(data) {
      const { message, customClass = 'for-school-docs-prompt', duration = 2000, type = 'success', offset = 80 } = data
      this.$message({
        message,
        type,
        duration,
        customClass,
        offset
      })
    },
    getMyOrgInfo() {
      api
        .getMyOrgInfo()
        .then(res => {
          this.qqGroupName = res.qqGroupName
          this.qqGroupNum = res.qqGroupNum
          this.qqGroupRq = res.qqGroupRq
        })
        .catch(err => {})
    },
    copy() {
      this.$trackSDK._trackEvent('邀请好友页面', '单击“一键复制”')
      if (this.inviteInfo.closed || this.inviteInfo.waitOpen) return
      let textArea = document.createElement('textarea')
      textArea.value = this.inviteUrl
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand('copy')
        this.$message({
          message: '已复制，粘贴分享给好友吧~',
          type: 'success',
          duration: 2000,
          customClass: 'for-invite-prompt',
          offset: 80
        })
      } catch (err) {
        this.$message({
          message: '该浏览器不支持点击复制到剪贴板',
          type: 'error',
          duration: 2000,
          customClass: 'for-invite-prompt',
          offset: 80
        })
      }
      document.body.removeChild(textArea)
    },
    getNextList() {
      // 第一次请求size为30，以后为15,，为了方便解决UI要求滚动条是否展示根据总数决定
      this.page++
      if (this.page === 1) this.page = 2
      if (this.page > 1) this.size = 15
      api.getTopList(this.page, this.size).then(res => {
        this.rank = res.rank
        this.campaignDays = res.campaignDays
        this.updateTime = res.generateTime
        if (res.topList.length === 0) {
          this.page--
        } else if (this.page === 0) {
          this.tableData = res.topList
        } else {
          this.tableData = this.tableData.concat(res.topList)
        }
      })
    },
    initPage() {
      this.getNextList()
      if (!this.inviteInfo.closed) {
        this.timer = setInterval(() => {
          this.page = -1
          this.size = 30
          this.timer = null
          this.getNextList()
        }, 5 * 60 * 1000)
      }
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
  components: {
    InviteList
  }
}
</script>
<style lang="scss" scoped>
.invite-page {
  background: #0a0724;
  background-image: url('~@/assets/img/invite/invitePageBg@2x.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 1366px auto;
  min-height: calc(100vh - 60px);
  &,
  * {
    box-sizing: border-box;
    color: #ffffff;
  }
  .invite-page-wrapper {
    width: 900px;
    margin: 0 auto;
    padding-top: 1135px;
  }
  .tipBox {
    display: flex;
    justify-content: space-between;
    .copyText,
    .timeText {
      height: 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      color: linear;
      background-image: linear-gradient(to right, #209cff, #68e0cf);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .copyBox {
    width: 900px;
    height: 104px;
    font-weight: 500;
    font-size: 18px;
    line-height: 104px;
    background: rgba(90, 159, 238, 0.15);
    border-radius: 16px;
    position: relative;
    text-indent: 24px;
    margin-top: 12px;
    .copyBtn {
      position: absolute;
      top: 23px;
      right: 24px;
      width: 190px;
      height: 56px;
      border-radius: 12px;
      font-weight: 500;
      font-size: 18px;
      line-height: 56px;
      color: #ffffff;
      text-align: center;
      text-indent: 0;
      background: linear-gradient(94.79deg, #209cff 0%, #68e0cf 100%);
      cursor: pointer;
      &:hover {
        background: linear-gradient(94.79deg, #0787ed 0%, #4bd2bf 100%);
      }
    }
  }
  .titleBox {
    width: 670px;
    height: 47px;
    margin: 0 auto;
    background: url('~@/assets/img/invite/title.png') no-repeat center;
    background-size: cover;
    margin-top: 48px;
  }
  .invCount {
    height: 28px;
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    margin-top: 24px;
  }
  .time {
    height: 14px;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    margin-top: 12px;
    margin-bottom: 20px;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
  }
  .info-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 8px;
    margin-top: 32px;
  }
  .info-content {
    &,
    * {
      font-size: 14px;
      line-height: 21px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .rules {
    display: flex;
    .rules-left {
      margin-right: 10px;
    }
  }
  .info-last {
    padding-bottom: 150px;
  }
  .qrCodeBox {
    display: inline-block;
    margin-left: 20px;
    position: relative;
    .qrBtn {
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url('~@/assets/img/invite/ic_arrow_gray_normal.png') no-repeat center;
      transform: rotate(-90deg);
      background-size: cover;
      &:hover {
        transform: rotate(0);
      }
    }
    .qrCode {
      width: 114px;
      height: 114px;
      position: absolute;
      left: 0;
      top: 25px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 106px;
        height: 106px;
      }
    }
    .qqGroupText {
      position: absolute;
      left: 124px;
      top: 55px;
      height: 48px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      padding: 6px 8px;
      &:after {
        display: block;
        content: '';
        position: absolute;
        left: -7px;
        top: 20px;
        width: 7px;
        height: 12px;
        background: url('~@/assets/img/invite/ic_arrow.png') no-repeat center;
        background-size: cover;
      }
      p {
        white-space: nowrap;
        font-size: 12px;
        line-height: 18px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
